import styled from 'styled-components';

import { themeSpace } from 'styles/themeUtils';

export const Section = styled.div`
  margin-top: ${themeSpace(2)};

  & + & {
    margin-top: ${themeSpace(2)};
  }
`;

Section.displayName = 'Section';

export const SubSection = styled.div`
  & + & {
    margin-top: ${themeSpace(2)};
  }
`;

SubSection.displayName = 'SubSection';
